import { Component, OnInit, Input } from '@angular/core';
import { faShareSquare } from '@fortawesome/pro-light-svg-icons';
import {SendToCaseComponent} from './../send-to-case/send-to-case.component';
import { CaseFilesService } from 'src/app/shared/services/casefiles.service';
import { ModalService } from 'src/app/shared/services/modal.service';

@Component({
  selector: 'app-unassigned-file',
  templateUrl: './unassigned-file.component.html',
  styleUrls: ['./unassigned-file.component.scss']
})
export class UnassignedFileComponent implements OnInit {

  @Input() details: any;
  @Input() selectable: boolean = false;
  @Input() selected: boolean = false;

  faShareSquare = faShareSquare;

  constructor(
    public caseFilesService: CaseFilesService,
    public modalService: ModalService) { }

  ngOnInit(): void {
  }


  sendToCase(){

    const modalRef = this.modalService.openWithOptions(SendToCaseComponent, {size: 'lg'});
    modalRef.componentInstance.file = this.details;
  }

}
